import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Input, Menu, Icon, Card } from 'semantic-ui-react'
import styled from 'styled-components'

import PromotionCard from '../../promotions/views/PromotionCard'
import ItemActions from '../../../reducers/itemReducer'

const Container = styled.div`
  display: flex;
`

const LeftContainer = styled.div`
  width: 400px;
  margin-right: 30px;
`

const RightContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

const PromotionList = styled.div`
  height: calc(100vh - 330px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 5px;
  padding-top: 5px;
`

const RestaurantRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const RestaurantName = styled.div`
  white-space: normal;
  word-break: break-all;
  line-height: 1.3;
  font-size: 15px
  flex: 1;
`

class ListPromotions extends React.PureComponent {
  state = {
    selectedRestaurant: null,
    searchValue: '',
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedRestaurant: prevSelectedRestaurant } = prevState
    const { selectedRestaurant } = this.state
    const { fetchItems } = this.props

    if (selectedRestaurant !== prevSelectedRestaurant) {
      fetchItems(selectedRestaurant)
    }
  }

  renderSearchRestaurantInput = () => (
    <Input
      type="text"
      placeholder="Search"
      name="search-restaurant"
      onChange={e => this.setState({ searchValue: e.target.value })}
      icon="search"
      style={{ width: '100%' }}
    />
  )

  renderRestaurantRow = ({ merchant_name: merchantName, merchant_id: merchantId }, promotionCount)  => {
    const { selectedRestaurant } = this.state
    const isSelected = merchantId === selectedRestaurant

    return (
      <RestaurantRow>
        <RestaurantName>{merchantName} ({promotionCount})</RestaurantName>
        { isSelected && <Icon name="angle right" color="black" /> }
      </RestaurantRow>
    )
  }

  renderRestaurantList = () => {
    const { selectedRestaurant, searchValue } = this.state
    const { promotionByMerchant } = this.props

    let restaurantsToDisplay = promotionByMerchant

    if (searchValue.length > 2) {
      restaurantsToDisplay = _.filter(promotionByMerchant, promo =>
        promo[0].merchant_name.toLowerCase().includes(searchValue.toLowerCase().toString())
      )
    }

    return (
      <div>
        {this.renderSearchRestaurantInput()}

        <Menu
          vertical
          style={{
            maxHeight: 'calc(100vh - 330px)',
            overflowY: 'auto',
            overflowX: 'hidden',
            width: '100%',
          }}
        >
          {_.map(restaurantsToDisplay, merchantPromotions => {
            const promotions = Object.values(merchantPromotions)
            const promotion = promotions[0]
            const isSelected = promotion.merchant_id === selectedRestaurant

            return (
              <Menu.Item
                key={promotion.merchant_id}
                active={isSelected}
                onClick={() => this.setState({ selectedRestaurant: promotion.merchant_id })}
              >
                {this.renderRestaurantRow(promotion, promotions.length)}
              </Menu.Item>
            )
          })}
        </Menu>
      </div>
    )
  }

  renderPromotions = () => {
    const { selectedRestaurant } = this.state
    const { promotionByMerchant, onDelete, onEdit } = this.props

    const promotions = (selectedRestaurant && promotionByMerchant[selectedRestaurant]) || []

    if (promotions.length === 0) return null

    return (
      <PromotionList>
        <Card.Group>
          {
            promotions.map(promotion => (
              <PromotionCard
                key={promotion.key}
                promotion={promotion}
                onDelete={() => onDelete(promotion)}
                onEdit={() => onEdit(promotion)}
              />
            ))
          }
        </Card.Group>
      </PromotionList>
    )
  }

  render() {
    return (
      <Container>
        <LeftContainer>
          {this.renderRestaurantList()}
        </LeftContainer>
        <RightContainer>
          {this.renderPromotions()}
        </RightContainer>
      </Container>
    )
  }
}

const mapDispatch = {
  fetchItems: ItemActions.fetchItemsByRestaurant,
}

export default connect(
  null,
  mapDispatch
)(ListPromotions)



// WEBPACK FOOTER //
// ./src/components/pickUpPromotions/views/ListPromotions.js